import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { hasValue } from 'Lib/Any';
import { Guid } from 'Lib/Guid';
import { BarcodeState, InitTareIdAction, PostBarcode, PostBarcodeResolve } from './types';

const name = 'barcode';

const initialState: BarcodeState = {
  barcode: '',
  isSyncing: false,
  isListeningForWedgeScan: false,
  isBarcodePanelOpen: false,
  activeWorkflow: null,
  responseMessage: null,
  focusedTareId: null,
  focusedRowUUID: null,
  tareIdList: [],
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    postBarcode: (state) => {
      state.isSyncing = true;
    },
    postBarcodeResolve: (state, action: PostBarcodeResolve) => {
      state.activeWorkflow = action.payload.ActiveWorkflow;
      state.responseMessage = action.payload.ResponseMessage;
      state.isSyncing = false;

      //TODO this is probably not the place to be doing this but works for now
      state.focusedRowUUID = null;
      //state.focusedTareId = action.payload.ActiveWorkflow.;
    },
    postBarcodeReject: (state) => {
      state.activeWorkflow = null;
      state.isSyncing = false;
    },
    barcodeClear: (state) => {
      state.barcode = '';
      state.activeWorkflow = null;
      state.responseMessage = null;
      state.isSyncing = false;
    },
    initTareId: (state, action: InitTareIdAction) => {
      if (hasValue(action.payload.index)) {
        state.tareIdList = [
          ...state.tareIdList.slice(0, action.payload.index),
          action.payload.tareId,
          ...state.tareIdList.slice(action.payload.index),
        ];
      } else state.tareIdList = [...state.tareIdList, action.payload.tareId];
    },
    cleanUpTareId: (state, action: PayloadAction<Guid>) => {
      state.tareIdList = state.tareIdList.filter((t) => t.id !== action.payload);
    },
    setFocusedTareId: (state, { payload: focusedTareId }: PayloadAction<Guid | null>) => {
      state.focusedTareId = focusedTareId;
    },
    setFocusedUUID: (state, { payload: focusedRowUUID }: PayloadAction<Guid>) => {
      state.focusedRowUUID = focusedRowUUID;
    },
    setWedgeScanning: (state, { payload: isListeningForWedgeScan }: PayloadAction<boolean>) => {
      state.isListeningForWedgeScan = isListeningForWedgeScan;
    },
    setBarcodePanelOpen: (state, { payload: isBarcodePanelOpen }: PayloadAction<boolean>) => {
      state.isBarcodePanelOpen = isBarcodePanelOpen;
    },
    updateBarcode: (state, action: PostBarcode) => {
      const { payload: { barcode, concat } = {} } = action;
      if (concat) {
        state.barcode = `${state.barcode}${barcode}`;
      } else {
        state.barcode = barcode;
      }
    },
  },
});

const { actions, reducer } = slice;
export { actions, reducer };
